import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { secondsToMinutes } from '../../utils';
import { reLogin, logout } from '../../utils/auth';
import { stopIdleTimer, startIdleTimer } from '../../utils/IdleTimer';
import styles from './LoginTimeout.style';
import Card from '../Card';

const logoutTimeInSeconds = 300;

const LoginTimeout = ({ dismiss }) => {
  const [countdown, setCountdown] = useState(logoutTimeInSeconds);

  useEffect(() => {
    // Stop the idle timer, start the logout timer (will run if dismissed as well)
    stopIdleTimer();
    startIdleTimer(logoutTimeInSeconds * 1000, logout);
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      setTimeout(() => setCountdown(countdown - 1), 1000);
    }
  }, [countdown]);

  return (
    <div className={styles.root}>
      <Card className={styles.loginBox}>
        <Stack tokens={{ childrenGap: 19 }}>
          <Text variant="xLarge">Your Session is About to Expire</Text>
          <Text variant="mediumPlus">
            You are about to exceed the maximum allocated time for this session. For security
            reasons, you will be automatically logged out in {secondsToMinutes(countdown)} minutes.
          </Text>
          <Stack horizontal align="end" tokens={{ childrenGap: 16 }} className={styles.buttons}>
            <DefaultButton text="Dismiss" onClick={dismiss} />
            <PrimaryButton text="Log back in now" onClick={reLogin} />
          </Stack>
        </Stack>
      </Card>
    </div>
  );
};

LoginTimeout.propTypes = {
  dismiss: PropTypes.func.isRequired,
};

export default LoginTimeout;
